// extracted by mini-css-extract-plugin
export var closeButton = "_73-0";